import styles from './IndicatorSeparator.module.scss'
import React from 'react'

const IndicatorSeparator = (props) => {
  if (!props.selectProps?.isSeparator) return null

  return (
    <div {...props}>
      <span className={styles.indicator} />
    </div>
  )
}

export { IndicatorSeparator }
